import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<Set<string>>(new Set());

  const toggleFAQ = (id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        data-seo-schema="true"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于东升大舞台的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIds.has(faq.id) ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIds.has(faq.id) ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}